import { render, staticRenderFns } from "./cooperateWineLists.vue?vue&type=template&id=19ce9c22&scoped=true&"
import script from "./cooperateWineLists.vue?vue&type=script&lang=js&"
export * from "./cooperateWineLists.vue?vue&type=script&lang=js&"
import style0 from "./cooperateWineLists.vue?vue&type=style&index=0&id=19ce9c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ce9c22",
  null
  
)

export default component.exports